import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
import router from '@/router'
import Sm2Util from '@/utils/utils.sm2'
// import qs from 'qs'
// 这里我自己重写了一下类型判断的所有方法，当然也可以用util库
import {
  isFormData,
  isArrayBuffer,
  isStream,
  isFile,
  isBlob,
  isURLSearchParams,
  isObject,
  isUndefined
} from './utils'

function setContentTypeIfUnset(headers, value) {
  if (!isUndefined(headers) && isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value
  }
}
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 60000, // request timeout
  headers: {
    'Content-Type': 'application/json; charset=utf-8;'
  },
  transformRequest: transformRequest
})

function transformRequest(data, headers) {
  /* 把类似content-type这种改成Content-Type */
  const keys = Object.keys(headers)
  const normalizedName = 'Content-Type'
  keys.forEach((name) => {
    if (
      name !== normalizedName &&
      name.toUpperCase() === normalizedName.toUpperCase()
    ) {
      headers[normalizedName] = headers[name]
      delete headers[name]
    }
  })
  if (isFormData(data)) {
    setContentTypeIfUnset(headers, 'multipart/form-data;charset=utf-8')
    // return data.toString()
    return data
  }
  if (isArrayBuffer(data) || isStream(data) || isFile(data) || isBlob(data)) {
    return data
  }
  // if (isURLSearchParams(data)) {
  //   setContentTypeIfUnset(
  //     headers,
  //     'application/x-www-form-urlencoded;charset=utf-8'
  //   )
  //   return data.toString()
  // }
  /* 这里是重点，其他的其实可以照着axios的源码抄 */
  /* 这里就是用来解决POST提交json数据的时候是直接把整个json放在request payload中提交过去的情况
   * 这里简单处理下，把 {name: 'admin', pwd: 123}这种转换成name=admin&pwd=123就可以通过
   * x-www-form-urlencoded这种方式提交
   * */
  // if (isObject(data)) {
  // setContentTypeIfUnset(
  //   headers,
  //   'application/x-www-form-urlencoded;charset=utf-8'
  // )
  setContentTypeIfUnset(
    headers,
    'application/json;charset=utf-8'
  )
  if (!data) {
    data = {}
  }
  data['timeStamp'] = new Date().getTime();
  var body = JSON.stringify(data);
  var content = Sm2Util.encrypt(body, process.env.VUE_APP_SYSTEM_PUBLIC_KEY)
  var sign = Sm2Util.sign(body, process.env.VUE_APP_PRIVATE_KEY);
  var json = {
    "content": content,
    "sign": sign
  }
  return JSON.stringify(json)

  // return data
}

// 设置axios为form-data
service.defaults.headers.post['Content-Type'] = 'application/json'
service.defaults.headers.get['Content-Type'] = 'application/json'

// request interceptor
service.interceptors.request.use(
  (config) => {
    if (process.env.VUE_APP_APP_ID) {
      config.url = config.url + `?app_id=${process.env.VUE_APP_APP_ID}`
    }
    if (store.getters.token) {
      config.headers['X-Token'] = getToken()
    }
    return config
  },
  (error) => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  (response) => {
    // 如果是导出 excel 跳过校验
    if (response.headers['content-disposition']) {
      return response
    }

    const res = response.data
    // if the custom code is not 20000, it is judged as an error.
    if (res['sign'] && res['content']) {
      var content = Sm2Util.decrypt(res['content'], process.env.VUE_APP_PRIVATE_KEY);
      var verifyResult = Sm2Util.verifySign(content, res['sign'], process.env.VUE_APP_SYSTEM_PUBLIC_KEY)
      if (verifyResult) {
        // console.log('验签成功');

        var dataJSON = JSON.parse(content)

        if (dataJSON.result != 10000) {
          Message({
            message: dataJSON.msg || '请求异常',
            type: 'error',
            duration: 3000
          })
          return Promise.reject(dataJSON)
        } else {
          return Promise.resolve(dataJSON)
        }

      } else {
        Message({
          message: '验签失败',
          type: 'error',
          duration: 3000
        })
        return Promise.reject(res)
      }
    } else {
      return Promise.resolve(res)
    }

  },
  (error) => {
    console.error("🚀 ~ error:", error)
    var status = error.response.status
    if (status == 401) {
      MessageBox.alert('用户信息过期', '退出', {
        confirmButtonText: '确定',
        type: 'warning',
        showClose: false,
        closeOnPressEscape: false,
        showCancelButton: false,
        beforeClose: (action, instance, done) => {
          done()
        }
      }).then(() => {
        store.dispatch('user/resetToken')
        router.push(`/login?redirect=${router.history.current.fullPath}`)
      })
    } else {
      // 隐藏 http 404 等 提示弹框
      Message({
        message: error.message,
        type: 'error',
        duration: 5000
      })
    }
    return Promise.reject(error)
  }
)

export default service
